import { DecimalPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';
import { QineticPositionService } from 'src/app/core/qinetic-position.service';

@Component({
  selector: 'app-orders-qinetic-reload-dialog',
  templateUrl: './orders-qinetic-reload-dialog.component.html',
  styleUrls: ['./orders-qinetic-reload-dialog.component.scss'],
})
export class OrdersQineticReloadDialogComponent {
  order?: Order;
  amount?: string;
  is_reload_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<OrdersQineticReloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private decimal_pipe: DecimalPipe,
    private qinetic_position_service: QineticPositionService,
    private error_service: ErrorService,
  ) {
    this.order = data.order;
    this.amount = `${this.formatNumber(this.order?.amount?.total || 0 / 1000)}€`;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.order && !this.is_reload_running) {
      this.is_reload_running = true;
      this.qinetic_position_service.create(this.order).subscribe({
        next: () => {
          this.dialog_ref.close({ success: true });
          this.is_reload_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.dialog_ref.close({ error: processed_error });
          this.is_reload_running = false;
        },
      });
    }
  }

  formatNumber(digits: number): string | null {
    return this.decimal_pipe.transform(digits / 100, '0.2-2', 'it-IT');
  }
}
